import { render, staticRenderFns } from "./credit.vue?vue&type=template&id=048dd8f7&scoped=true&"
import script from "./credit.vue?vue&type=script&lang=js&"
export * from "./credit.vue?vue&type=script&lang=js&"
import style0 from "./credit.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./credit.vue?vue&type=style&index=1&lang=scss&"
import style2 from "./credit.vue?vue&type=style&index=2&id=048dd8f7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "048dd8f7",
  null
  
)

export default component.exports